export default function TakeoutBand() {
  return (
    <section className="bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 pb-16 md:px-6">
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20editorial%20band%20of%20warm%20coral%20and%20amber%20gradient%20with%20scattered%20phone%20screens%2C%20play%20buttons%20and%20download%20icons%2C%20layered%20paper%20cutouts%2C%20film%20grain%2C%20cinematic%20archive%20mood%2C%20no%20readable%20text%2C%20no%20identifiable%20faces&width=1600&height=500&seq=chigua-cta-band&orientation=landscape"
            alt="98吃瓜 素材速取工具横幅"
            className="h-64 w-full object-cover md:h-72"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/10" />
          <div className="absolute inset-0 flex flex-col items-start justify-center px-6 md:px-12">
            <span className="rounded-full bg-amber px-3 py-1 text-xs font-bold text-ink">
              <i className="ri-lightbulb-flash-line mr-1" />
              素材速取
            </span>
            <h2 className="mt-4 max-w-xl font-display-x text-3xl font-black leading-tight text-cream md:text-4xl">
              同一主题，片段、截图、录屏、回放一次配齐
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-cream/85 md:text-base">
              不用在多个平台来回跳，按传播节奏顺着分区取即可，跟上更新节奏更省力。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a
                href="#shots"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-amber px-6 py-3 text-sm font-bold text-ink transition hover:bg-peach"
              >
                <i className="ri-download-cloud-2-line text-lg" />
                现在就取素材
              </a>
              <a
                href="#faq"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-cream/15 px-6 py-3 text-sm font-bold text-cream ring-1 ring-cream/30 backdrop-blur transition hover:bg-cream/25"
              >
                <i className="ri-question-line text-lg" />
                先看使用说明
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}